module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "licitacion__modal-mobile",
    attrs: {
      "title": "Prorrogar Compulsa",
      "visible": _vm.extendDateDialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.extendDateDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("¿Desea notificar a los participantes de la compulsa?")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "display": "block",
      "margin-top": "20px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-text": "Si",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.checkBoxSendMail),
      callback: function($$v) {
        _vm.checkBoxSendMail = $$v
      },
      expression: "checkBoxSendMail"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.extendDateDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.extendLicitacionDate(_vm.licitacion)
      }
    }
  }, [_vm._v("Confirmar")])], 1)])]), _vm._v(" "), (_vm.licitacion) ? _c('el-dialog', {
    attrs: {
      "title": 'Proceso de Compra',
      "visible": _vm.showModalLicitacion,
      "close-on-click-modal": false,
      "width": "100%",
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalLicitacion = $event
      },
      "closed": function($event) {
        return _vm.resetLicitacion()
      }
    }
  }, [_c('div', {
    staticClass: "licitacion__body-mobile"
  }, [(!_vm.user.isProvider && !_vm.licitacionTerminada() && this.licitacion.status.idLicitacionStatus !== '4' && this.licitacion.status.idLicitacionStatus !== '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio aún no ha finalizado",
      "type": "warning",
      "closable": false,
      "description": "No se mostrarán las propuestas hasta que la licitación finalice",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada() && this.licitacion.status.idLicitacionStatus === '4') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha sido cancelada",
      "type": "error",
      "closable": false,
      "description": "No se podran enviar y/o editar mas propuestas",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && this.licitacion.status.idLicitacionStatus === '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha finalizado",
      "type": "warning",
      "closable": false,
      "description": "No podrá enviar y/o editar una propuesta",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && this.licitacion.status.idLicitacionStatus === '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha finalizado",
      "type": "warning",
      "description": "No se podran enviar y/o editar mas propuestas",
      "closable": false,
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('p', {
    staticStyle: {
      "padding-right": "30px",
      "marginBottom": "-15px",
      "font-size": "22px",
      "color": "#333333",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.nombre))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.licitacion.codPO != null) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "bold",
      "color": "#5e6c84"
    }
  }, [_vm._v("Codigo: " + _vm._s(_vm.licitacion.codPO))]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Descripción")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-justify": "auto",
      "word-break": "keep-all",
      "marginTop": "25px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.licitacion.cuerpo)
    }
  })], 1), _vm._v(" "), (_vm.licitacion) ? _c('el-col', {
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "span": 4
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#5e6c84"
    }
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.status.descripcion))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84",
      "word-break": "keep-all"
    }
  }, [_vm._v("FECHA DE INICIO")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.fecha_inicio))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "word-break": "keep-all",
      "color": "#5e6c84"
    }
  }, [_vm._v("FECHA DE FINALIZACIÓN")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.fecha_fin))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("SUPERVISOR")]), _vm._v(" "), (_vm.licitacion.supervisor != null) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.supervisorName))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("RESPONSABLES")]), _vm._v(" "), _vm._l((_vm.licitacion.buyersNames), function(manager, index) {
    return _c('span', {
      key: manager,
      staticStyle: {
        "font-size": "15px",
        "color": "#172b4d",
        "text-align": "justify",
        "text-justify": "auto",
        "word-break": "keep-all"
      }
    }, [(index == _vm.licitacion.buyersNames.length - 1) ? _c('span', [_vm._v(_vm._s(manager))]) : _c('span', [_vm._v(_vm._s(manager) + ", ")])])
  }), _vm._v(" "), (_vm.licitacion.buyers.length <= 0) ? _c('div', [_c('p', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("OFERTAS PRESENTADAS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "word-break": "keep-all"
    }
  }, [_vm._v(_vm._s(_vm.offerAmount) + "/" + _vm._s(_vm.licitacion.proveedores.length))])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', [_c('el-date-picker', {
    staticStyle: {
      "margin-top": "20px",
      "width": "188px"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          return _vm.pastDateToday(date)
        }
      }
    },
    model: {
      value: (_vm.extensionDate),
      callback: function($$v) {
        _vm.extensionDate = $$v
      },
      expression: "extensionDate"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.extensionDate === null,
      "icon": "el-icon-timer"
    },
    on: {
      "click": function($event) {
        _vm.extendDateDialog = true
      }
    }
  }, [_vm._v("Prorrogar Compulsa")])], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px",
      "margin-right": "-1%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Archivos de la compulsa")])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licitacion.documents,
      "height": "auto"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "Comentario",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PDF"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-document",
            "circle": ""
          }
        })], 1)]
      }
    }], null, false, 258742780)
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', [_c('el-col', {
    staticStyle: {
      "margin-top": "5%"
    },
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "#5e6c84"
    }
  }, [_vm._v("Adjuntar un documento")])]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "70%",
      "margin-top": "10px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "Inserte comentario"
    },
    model: {
      value: (_vm.documentComment),
      callback: function($$v) {
        _vm.documentComment = $$v
      },
      expression: "documentComment"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "limit": 1,
      "accept": "application/pdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": false,
      "on-success": _vm.handlePdfCompulsa,
      "multiple": "",
      "show-file-list": true,
      "data": {
        folder: 'documentsCompulsa'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar documento")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Subir")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 24
    }
  }, [(!_vm.user.isProvider && _vm.licitacionTerminada()) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#172b4d",
      "font-weight": "bold"
    }
  }, [_vm._v("Oferta"), (!_vm.user.isProvider) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && _vm.licitacion.status.idLicitacionStatus === '2') ? _c('table', {
    staticClass: "table",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Ofertas")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Oferta técnica")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [(!_vm.licitacion.oferta_tec || _vm.editTec) ? _c('input', {
    ref: "fileOfertaTec",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left",
      "font-size": "14px"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "data-cy": "oferta-tecnica"
    },
    on: {
      "change": function($event) {
        return _vm.uploadOferta('tec')
      }
    }
  }) : _c('div', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.licitacion.oferta_tec,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF\n                            ")]), _vm._v(" "), (_vm.licitacion.visto !== '2') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        _vm.editTec = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Oferta económica")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [(!_vm.licitacion.oferta_eco || _vm.editEco) ? _c('input', {
    ref: "fileOfertaEco",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left",
      "font-size": "14px"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "data-cy": "oferta-economica"
    },
    on: {
      "change": function($event) {
        return _vm.uploadOferta('eco')
      }
    }
  }) : _c('div', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.licitacion.oferta_eco,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF\n                            ")]), _vm._v(" "), (_vm.licitacion.visto !== '2') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        _vm.editEco = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  })]), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [(_vm.showUpload) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-upload"
    },
    on: {
      "click": _vm.uploadOfertas
    }
  }, [_vm._v("\n                        Subir ofertas\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.showUpload && _vm.canConfirm) ? _c('el-button', {
    staticStyle: {
      "margin-left": "6%",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.confirmOfertas
    }
  }, [_vm._v("\n                        Confirmar Oferta\n                      ")]) : _vm._e()], 1), _vm._v(" "), _c('el-divider')], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && _vm.licitacion.status.idLicitacionStatus === '3') ? _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Ofertas de los Proveedores")])]), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.licitacion.propuestas,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, [_vm._l((_vm.propuestasTable), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Oferta Técnica"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.oferta_tec,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2169091004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Oferta Económica"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.oferta_eco,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 1741807207)
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.user.isProvider) ? _c('div', [(!_vm.licitacionTerminada()) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "black",
      "font-size": "14px",
      "font-weight": "bold",
      "margin-left": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Nueva consulta")]), _vm._v(" "), _c('div', {
    staticClass: "entrada"
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Consulta",
      "rows": 3,
      "resize": 'vertical'
    },
    model: {
      value: (_vm.newQuestion),
      callback: function($$v) {
        _vm.newQuestion = $$v
      },
      expression: "newQuestion"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.sendConsulta(null, 0, 2)
      }
    }
  }, [_vm._v("\n                              Enviar Consulta\n                          ")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Tus consultas")])]), _vm._v(" "), (_vm.queries.length == 0) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "No hay consultas",
      "type": "warning",
      "closable": false,
      "description": "Aun no has hecho ninguna consulta.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeQuestions),
      callback: function($$v) {
        _vm.activeQuestions = $$v
      },
      expression: "activeQuestions"
    }
  }, _vm._l((_vm.questions), function(item) {
    return _c('el-collapse-item', {
      key: item.idMessage,
      attrs: {
        "name": item.idMessage
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.message))])]), _vm._v(" "), (item.answer) ? _c('div', {
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_c('i', {
      staticClass: "far fa-comment-dots"
    }), _vm._v(" " + _vm._s(item.message) + " ")]) : _vm._e(), _vm._v(" "), (!item.answer) ? _c('div', {
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_vm._v("Aun no hay respuesta para esta consulta")]) : _vm._e()], 2)
  }), 1), _vm._v(" "), (_vm.queries.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "50px"
    },
    attrs: {
      "data": _vm.queries,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))]), _vm._v(" "), (props.row.respuesta.message == '') ? _c('div', {
          staticStyle: {
            "margin-left": "3%",
            "font-size": "12px"
          }
        }, [_c('b', [_vm._v("Esta consulta aun no tiene respuesta")])]) : _vm._e()]
      }
    }], null, false, 2974492279)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "400",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-size": "20px",
      "color": "#303133",
      "padding-bottom": "100px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas Frecuentes")])]), _vm._v(" "), (_vm.FAQ.length == 0) ? _c('el-alert', {
    attrs: {
      "title": "No hay consultas frecuentes",
      "type": "warning",
      "closable": false,
      "description": "Aun no se ha marcado ninguna pregunta como frecuente.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.FAQ.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FAQ,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))])]
      }
    }], null, false, 642903549)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "400",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('div', {
    staticStyle: {
      "margin-top": "2%"
    }
  }, [(_vm.queries.length > 0) ? _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.queries.length === 0) ? _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.queries.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "50px"
    },
    attrs: {
      "data": _vm.queries,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "300",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "50",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.respuesta.message != '') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consulta Frecuente",
            "placement": "left-start"
          }
        }, [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "2"
          },
          on: {
            "change": function($event) {
              return _vm.actualizarTipoConsulta(props.row)
            }
          },
          model: {
            value: (props.row.messageType),
            callback: function($$v) {
              _vm.$set(props.row, "messageType", $$v)
            },
            expression: "props.row.messageType"
          }
        })], 1) : _vm._e()]
      }
    }], null, false, 4051403753)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))]), _vm._v(" "), _c('p', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v(_vm._s(props.row.respuesta.name))]), _vm._v(" "), (props.row.respuesta.message == '') ? _c('div', [_c('el-input', {
          attrs: {
            "type": "textarea",
            "required": "",
            "placeholder": "Respuesta",
            "rows": 3,
            "resize": 'none'
          },
          model: {
            value: (_vm.respuestas[props.row.idMessage]),
            callback: function($$v) {
              _vm.$set(_vm.respuestas, props.row.idMessage, $$v)
            },
            expression: "respuestas[props.row.idMessage]"
          }
        }), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary",
          staticStyle: {
            "float": "right"
          },
          on: {
            "click": function($event) {
              return _vm.sendAnswer(props.row.idMessage, props.row.idEmisor, _vm.respuestas[props.row.idMessage], props.row)
            }
          }
        }, [_vm._v("Enviar Respuesta")])], 1) : _vm._e()]
      }
    }], null, false, 2066910626)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas Frecuentes")])])], 1), _vm._v(" "), (_vm.FAQ.length == 0) ? _c('el-alert', {
    attrs: {
      "title": "No hay consultas frecuentes",
      "type": "warning",
      "closable": false,
      "description": "Aun no se ha marcado ninguna pregunta como frecuente.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.FAQ.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FAQ,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "250",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Eliminar Consulta",
            "placement": "left-start"
          }
        }, [_c('el-button', {
          staticStyle: {
            "margin-left": "90px"
          },
          attrs: {
            "type": "danger",
            "size": "mini",
            "round": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteLicitacionesConsulta(props.row)
            }
          }
        }, [_vm._v("Eliminar")])], 1)]
      }
    }], null, false, 457737662)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.idEmisor !== '1') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consulta Frecuente",
            "placement": "left-start"
          }
        }, [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "2"
          },
          on: {
            "change": function($event) {
              return _vm.actualizarTipoConsulta(props.row)
            }
          },
          model: {
            value: (props.row.messageType),
            callback: function($$v) {
              _vm.$set(props.row, "messageType", $$v)
            },
            expression: "props.row.messageType"
          }
        })], 1) : _vm._e()]
      }
    }], null, false, 1240699936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))])]
      }
    }], null, false, 642903549)
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Crear nuevas consultas frecuentes")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "25px",
      "margin-top": "10px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Pregunta",
      "rows": 4,
      "resize": 'none'
    },
    model: {
      value: (_vm.newQuestion),
      callback: function($$v) {
        _vm.newQuestion = $$v
      },
      expression: "newQuestion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-input', {
    staticStyle: {
      "margin-left": "-15px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Respuesta",
      "rows": 3,
      "resize": 'none'
    },
    model: {
      value: (_vm.respuestaFrecuente),
      callback: function($$v) {
        _vm.respuestaFrecuente = $$v
      },
      expression: "respuestaFrecuente"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.sendConsultaFrecuente()
      }
    }
  }, [_vm._v("\n                  Agregar pregunta frecuente\n              ")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.providers && !_vm.user.isProvider && _vm.licitacion) ? _c('el-dialog', {
    attrs: {
      "title": 'Proveedores de la compulsa ' + _vm.licitacion.nombre,
      "visible": _vm.showModalLicitacionProviders,
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalLicitacionProviders = $event
      },
      "closed": function($event) {
        _vm.licitacion = ''
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7,
      "xs": 24
    }
  }, [_c('el-select', {
    staticClass: "provider__select-mobile",
    attrs: {
      "clearable": "",
      "placeholder": "Rubro",
      "multiple": ""
    },
    model: {
      value: (_vm.filtersRubro[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersRubro[0], "value", $$v)
      },
      expression: "filtersRubro[0].value"
    }
  }, _vm._l((_vm.rubros), function(item, index) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "value": item.idRubro + index,
        "label": item.nombre
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "xs": 24
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Identificación Fiscal / Nombre"
    },
    model: {
      value: (_vm.filtersRubro[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersRubro[1], "value", $$v)
      },
      expression: "filtersRubro[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "table-responsive licitaciones__table-mobile",
    attrs: {
      "data": _vm.providersParaCompulsa,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filtersRubro
    }
  }, [(_vm.needProviders(_vm.licitacion)) ? _c('el-table-column', {
    attrs: {
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.providersSelected),
            expression: "providersSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": scope.row.idCompany,
            "checked": Array.isArray(_vm.providersSelected) ? _vm._i(_vm.providersSelected, scope.row.idCompany) > -1 : (_vm.providersSelected)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.providersSelected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = scope.row.idCompany,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.providersSelected = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.providersSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.providersSelected = $$c
              }
            }
          }
        })]
      }
    }], null, false, 645316143)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "fiscalId",
      "label": "Id Fiscal"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "idType",
      "label": "Id Tipo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Proveedor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getCompanyName(scope.row)) + "\n              ")]
      }
    }], null, false, 978644772)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro + index
          }, [_vm._v("\n                      " + _vm._s(rubro.nombre) + "\n                      "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                        /\n                      ")]) : _vm._e()])
        })
      }
    }], null, false, 641394912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(scope.row.calification = Number(scope.row.calification)))]), _vm._v(" "), _c('el-rate', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", $$v)
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }], null, false, 2555398763)
  })], 1), _vm._v(" "), (_vm.needProviders(_vm.licitacion)) ? _c('div', {
    staticClass: "licitacion__buttons-mobile"
  }, [_c('button', {
    staticClass: "btn btn-secondary licitacion__button-mobile",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.providersSelected = []
      }
    }
  }, [_vm._v("\n          Limpiar selección\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary licitacion__button-mobile",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.guardarProveedores
    }
  }, [_vm._v("\n          Guardar proveedores\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary licitacion__button-mobile",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "disabled": _vm.providersSelected.length === 0
    },
    on: {
      "click": _vm.invitarProviders
    }
  }, [_vm._v("\n          Invitar proveedor"), (_vm.providersSelected.length > 1) ? _c('span', [_vm._v("es (" + _vm._s(_vm.providersSelected.length) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary licitacion__accept-mobile",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.showModalLicitacionProviders = false
      }
    }
  }, [_vm._v("\n          Aceptar\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Agregar una compulsa",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": function($event) {
        return _vm.resetLicitacion()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Nombre"
    },
    model: {
      value: (_vm.licitacionNueva.nombre),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "nombre", $$v)
      },
      expression: "licitacionNueva.nombre"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Descripción")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('vue-editor', {
    model: {
      value: (_vm.licitacionNueva.cuerpo),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "cuerpo", $$v)
      },
      expression: "licitacionNueva.cuerpo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Fecha de inicio")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-date-picker', {
    staticClass: "licitacion__date-mobile",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha inicio",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          return _vm.pastDateToday(date)
        }
      }
    },
    on: {
      "change": function($event) {
        return _vm.checkFinalDate()
      }
    },
    model: {
      value: (_vm.licitacionNueva.fecha_inicio),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "fecha_inicio", $$v)
      },
      expression: "licitacionNueva.fecha_inicio"
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.licitacionNueva.fecha_inicio) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Fecha de finalización")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-date-picker', {
    staticClass: "licitacion__date-mobile",
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha finalizacion",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          if (date !== null) {
            return _vm.pastDateInitialDate(date) || _vm.pastDateToday(date)
          }
        }
      }
    },
    model: {
      value: (_vm.licitacionNueva.fecha_fin),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "fecha_fin", $$v)
      },
      expression: "licitacionNueva.fecha_fin"
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.licitacionNueva.fecha_inicio) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Comprador")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    staticClass: "licitacion__select-mobile",
    attrs: {
      "required": "",
      "multiple": "",
      "placeholder": "Seleccionar Comprador"
    },
    model: {
      value: (_vm.currentIdBuyer),
      callback: function($$v) {
        _vm.currentIdBuyer = $$v
      },
      expression: "currentIdBuyer"
    }
  }, _vm._l((_vm.buyers.userJobs), function(item) {
    return _c('el-option', {
      key: item.idUser,
      attrs: {
        "value": item.idUser,
        "label": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "licitacion__input-mobile"
  }, [_vm._v("Supervisor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    staticClass: "licitacion__select-mobile",
    attrs: {
      "required": "",
      "placeholder": "Seleccionar Supervisor"
    },
    model: {
      value: (_vm.licitacionNueva.supervisor),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "supervisor", $$v)
      },
      expression: "licitacionNueva.supervisor"
    }
  }, _vm._l((_vm.boss.userJobs), function(item) {
    return _c('el-option', {
      key: item.idUser,
      attrs: {
        "value": item.idUser,
        "label": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [(_vm.licitacionAlert) ? _c('el-alert', {
    attrs: {
      "type": "error",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, _vm._l((_vm.erroresLicitacion), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(error) + "\n                    ")])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.guardarLicitacion()
      }
    }
  }, [_vm._v("\n        Guardar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [(!_vm.user.isProvider) ? _c('el-col', {
    attrs: {
      "span": 6,
      "xs": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("Agregar")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "xs": 24
    }
  }, [_c('el-input', {
    staticClass: "provider__select-mobile",
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "xs": 24
    }
  }, [_c('el-select', {
    staticClass: "provider__select-mobile",
    attrs: {
      "multiple": "",
      "placeholder": "Estado"
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  }, _vm._l((_vm.licitacionesStatus), function(item) {
    return _c('el-option', {
      key: item.idLicitacionStatus,
      attrs: {
        "value": item.descripcion,
        "label": item.descripcion
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "licitaciones__table-mobile",
    attrs: {
      "data": _vm.licitaciones,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actividad"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.status.descripcion) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.visto === '0') ? _c('span', [_vm._v(" Invitado ")]) : _vm._e(), _vm._v(" "), (scope.row.visto === '1') ? _c('span', [_vm._v(" Visto ")]) : _vm._e(), _vm._v(" "), (scope.row.visto === '2') ? _c('span', [_vm._v(" Enviado ")]) : _vm._e()]
      }
    }], null, false, 3336981154)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.user.isProvider) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consultas a responder",
            "placement": "top-end"
          }
        }, [_c('el-badge', {
          staticClass: "item",
          attrs: {
            "value": _vm.questionsWithoutResponse(scope.row)
          }
        }, [_c('el-button', {
          staticStyle: {
            "cursor": "default"
          },
          attrs: {
            "disabled": "",
            "type": "warning",
            "size": "mini",
            "icon": "el-icon-bell",
            "circle": ""
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.seeDetails(scope.row)
            }
          }
        })], 1), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.needProviders(scope.row) ? 'Agregar proveedores' : 'Ver proveedores',
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": _vm.needProviders(scope.row) ? 'success' : 'info',
            "icon": _vm.needProviders(scope.row) ? 'el-icon-plus' : 'fa fa-user',
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.seeProviders(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && scope.row.status.idLicitacionStatus !== '1' && scope.row.status.idLicitacionStatus !== '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancelar compulsa",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-video-pause",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.cancelarLicitacion(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && scope.row.status.idLicitacionStatus == '1' && scope.row.status.idLicitacionStatus !== '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Borrar compulsa",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.borrarLicitacion(scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8a6fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Licitaciones.vue
// module id = 625
// module chunks = 1